import { API_URLS } from "../constants";
import { postRequest } from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";

const { EMAIL } = API_URLS;

//Getting Paginated Survey Queues
const getSurveyQueues = (body) => {
  return postRequest(EMAIL.BASE, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const sendEmailMessage = (emailId) => {
  return postRequest(`${EMAIL.SEND_EMAIL_MESSAGE}/${emailId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Exporting functions for other files
export const surveyQueuesServices = {
  getSurveyQueues,
  sendEmailMessage,
};
